export const config = {
  rowSelection: false,
  columns: [
    {
      title: '物料SPU编码',
      key: 'code',
      dataIndex: 'code',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '物料SPU名称',
      key: 'name',
      dataIndex: 'name',
      width: 200,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '物料SPU描述',
      key: 'description',
      dataIndex: 'description',
      width: 120,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '品牌',
      key: 'brandName',
      dataIndex: 'brandName',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产地',
      key: 'manuLocation',
      dataIndex: 'manuLocation',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '物料类型',
      key: 'typeName',
      dataIndex: 'typeName',
      width: 100,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '同步次数',
      key: 'syncNum',
      dataIndex: 'syncNum',
      width: 140,
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 100,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'code',
      label: '物料SPU编码',
      itemType: 'input',
      placeholder: '请输入物料SPU编码'
    },
    {
      name: 'nameKeyword',
      label: '物料SPU名称',
      itemType: 'input',
      placeholder: '请输入物料SPU名称'
    },
  ],
  footer: [
  ],
  batchActions: [
  ],
}
